export const db_client = {
    budget: "",
    email: "",
    firstname: "",
    id: "",
    lastname: "",
    phone: "",
    shortlink: "",
    active: true
}